<template>
    <div class="d-flex flex-column overflow-hidden">
        <b-form
            v-on:submit.prevent="$_onSubmit"
            class="d-flex flex-column overflow-hidden"
        >
            <div class="scrollable mb-3">
                <b-container>
                    <category
                        :categories="categories"
                        :accordion="true"
                        :inputFields="inputFields"
                        id="brpCategories"
                        @onChange="$_validateDate($event)"
                        @onCategoryShow="$_onCategoryShow($event)"
                        :invalidFieldValueErrorMessage="
                            invalidFieldValueErrorMessage
                        "
                    />
                </b-container>
            </div>
            <div v-if="invalidForm" class="errormsg px-4 mb-2">
                {{ invalidFormErrorMessage }}
            </div>
            <b-container>
                <b-row>
                    <b-col class="text-right pb-4">
                        <b-button variant="primary" type="submit">
                            <span>
                                {{ $t('searchButtonText') }}
                            </span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
    </div>
</template>

<script>
    import { FIELD_TYPE } from '../../../constants';
    import { reverseDate } from '../../../services/utilities/utilities';
    import { validateDate } from '../../../services/utilities/validator';
    import Category from './ApiCategory.vue';

    export default {
        components: { category: Category },
        data() {
            return {
                invalidFieldValueErrorMessage: '',
                invalidForm: false,
                invalidFormErrorMessage: '',
                types: [
                    'RaadpleegMetBurgerservicenummer',
                    'ZoekMetGeslachtsnaamEnGeboortedatum',
                    'ZoekMetNaamEnGemeenteVanInschrijving',
                    'ZoekMetPostcodeEnHuisnummer',
                    'ZoekMetStraatHuisnummerEnGemeenteVanInschrijving',
                    'ZoekMetNummeraanduidingIdentificatie'
                ],
                categories: [
                    {
                        label: this.$t('brp.searchCat1'),
                        category: 1,
                        expanded: true
                    },
                    {
                        label: this.$t('brp.searchCat2'),
                        category: 2,
                        expanded: false
                    },
                    {
                        label: this.$t('brp.searchCat3'),
                        category: 3,
                        expanded: false
                    },
                    {
                        label: this.$t('brp.searchCat4'),
                        category: 4,
                        expanded: false
                    },
                    {
                        label: this.$t('brp.searchCat5'),
                        category: 5,
                        expanded: false
                    },
                    {
                        label: this.$t('brp.searchCat6'),
                        category: 6,
                        expanded: false
                    }
                ],
                inputFields: [
                    {
                        label: this.$t('brp.citizenServiceNumber'),
                        key: 'burgerservicenummer',
                        value: '',
                        category: 1,
                        maxlength: 9,
                        pattern: '^[0-9]{9}$',
                        title: '9 cijfers'
                    },
                    {
                        label: this.$t('brp.lastName'),
                        key: 'geslachtsnaam',
                        value: '',
                        category: [2, 3],
                        maxlength: 200,
                        info: this.$t('brp.wildcardAllowedNumberOfChars', [3])
                    },
                    {
                        label: `${this.$t('brp.dateOfBirth')} (dd-mm-jjjj)`,
                        key: 'geboortedatum',
                        value: '',
                        category: 2,
                        maxlength: 10,
                        type: FIELD_TYPE.DATE
                    },
                    {
                        label: this.$t('brp.firstNames'),
                        key: 'voornamen',
                        value: '',
                        category: [2, 3],
                        maxlength: 200,
                        info: this.$t('brp.wildcardAllowed')
                    },
                    {
                        label: this.$t('brp.prefix'),
                        key: 'voorvoegsel',
                        value: '',
                        category: [2, 3],
                        maxlength: 10
                    },
                    {
                        label: `${this.$t('brp.gender')} (M/V/O)`,
                        key: 'geslacht',
                        value: '',
                        category: [2, 3],
                        maxlength: 1,
                        pattern: '^([Mm]|[Vv]|[Oo])$',
                        title: 'M, V of O'
                    },
                    {
                        label: this.$t('brp.streetName'),
                        key: 'straat',
                        value: '',
                        category: 5,
                        maxlength: 100,
                        info: this.$t('brp.wildcardAllowedNumberOfChars', [7])
                    },
                    {
                        label: this.$t('brp.postalCode'),
                        key: 'postcode',
                        value: '',
                        category: 4,
                        maxlength: 7,
                        pattern: '^[1-9]{1}[0-9]{3}[ ]?[A-Za-z]{2}$',
                        title: 'formaat: 1234AB of 1234 AB'
                    },
                    {
                        label: this.$t('brp.houseNumber'),
                        key: 'huisnummer',
                        value: null,
                        category: [4, 5],
                        maxlength: 1000,
                        type: FIELD_TYPE.NUMERIC
                    },
                    {
                        label: this.$t('brp.houseLetter'),
                        key: 'huisletter',
                        value: '',
                        category: [4, 5],
                        maxlength: 1,
                        pattern: '^[a-zA-Z]{1}$'
                    },
                    {
                        label: this.$t('brp.houseNumberAddition'),
                        key: 'huisnummertoevoeging',
                        value: '',
                        category: [4, 5],
                        maxlength: 4,
                        pattern: '^[0-9a-zA-Z]{1,4}$',
                        title: 'combinatie van hoofdletters, kleine letters en/of cijfers'
                    },
                    {
                        label: this.$t('brp.numberDesignation'),
                        key: 'nummeraanduidingIdentificatie',
                        value: '',
                        category: 6,
                        maxlength: 16,
                        pattern: '^[0-9]{16}$',
                        title: '16 cijfers'
                    },
                    {
                        label: this.$t('brp.municipalityRegistration'),
                        key: 'gemeenteVanInschrijving',
                        value: '',
                        category: [1, 2, 3, 4, 5, 6],
                        maxlength: 4,
                        pattern: '^[0-9]{4}$',
                        title: 'Code van de gemeente bestaande uit 4 cijfers'
                    },
                    {
                        label: this.$t('brp.includingDeceasedPersons'),
                        key: 'inclusiefOverledenPersonen',
                        value: null,
                        category: [2, 3, 4, 5, 6],
                        maxlength: 10,
                        domain: {
                            keyvalues: [
                                {
                                    value: 'true',
                                    text: this.$t('btnTitleYes')
                                },
                                {
                                    value: 'false',
                                    text: this.$t('btnTitleNo')
                                }
                            ]
                        }
                    }
                ]
            };
        },
        computed: {
            $_categoryExpanded() {
                return this.categories.findIndex((item) => item.expanded) + 1;
            },
            $_isCategoryExpanded() {
                return (category) =>
                    category === this.$_categoryExpanded ||
                    (Array.isArray(category) &&
                        category.includes(this.$_categoryExpanded));
            }
        },
        methods: {
            async $_onSubmit() {
                let query = {};
                // Only add fields that have a value
                this.inputFields.forEach((item) => {
                    const value = typeof item.value === 'string' ? item.value.trim() : item.value;
                    if (
                        value !== null &&
                        value !== '' &&
                        this.$_isCategoryExpanded(item.category)
                    ) {
                        if (item.key === 'burgerservicenummer') {
                            query[item.key] = [value];
                        } else if (item.key === 'geboortedatum') {
                            query[item.key] = reverseDate(value);
                        } else {
                            query[item.key] = value;
                        }
                    }
                });
                let fields;
                if (this.$_categoryExpanded === 1) {
                    fields = [
                        'burgerservicenummer',
                        'adressering',
                        'geboorte',
                        'geslacht',
                        'naam',
                        'overlijden',
                        'verblijfplaatsBinnenland',
                        'adresseringBinnenland',
                        'gemeenteVanInschrijving'
                    ];
                } else {
                    fields = [
                        'adressering',
                        'burgerservicenummer',
                        'geboorte',
                        'geslacht',
                        'naam',
                        'adresseringBinnenland'
                    ];
                }

                const data = {
                    type: this.types[this.$_categoryExpanded - 1],
                    fields,
                    ...query
                };

                this.$store.commit('CLEAR_SELECTIONS');
                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_START');

                if (this.$_isValidForm(query)) {
                    this.$store.dispatch('getBrpData', {
                        data,
                        type: 'personen',
                        title: this.$t('brp.persons')
                    });
                }

                this.$store.commit('NEDGLOBE_MOBILE_DISPLAY_SELECTION_END');
            },

            $_missingSearchFieldsMessage(_query) {
                const query = JSON.parse(JSON.stringify(_query));
                if (!query) {
                    return this.$t('brp.missingSearchFields');
                }
                const category = this.$_categoryExpanded;
                const requiredFields = {
                    1: ['burgerservicenummer'],
                    2: ['geslachtsnaam', 'geboortedatum'],
                    3: ['geslachtsnaam', 'voornamen', 'gemeenteVanInschrijving'],
                    4: ['postcode', 'huisnummer'],
                    5: ['straat', 'huisnummer', 'gemeenteVanInschrijving'],
                    6: ['nummeraanduidingIdentificatie']
                };
                const missingFields = requiredFields[category].filter(
                    (field) => !query[field]
                );
                if (missingFields.length > 0) {
                    return this.$t(`brp.incorrectCat${category}`);
                }
                return '';
            },

            $_isValidForm(query) {
                this.invalidForm = false;
                this.invalidFormErrorMessage =
                    this.$_missingSearchFieldsMessage(query);

                if (this.invalidFormErrorMessage) {
                    this.invalidForm = true;
                    return false;
                }

                if (this.$_hasInvalidStateFields(query)) {
                    this.invalidFormErrorMessage = this.$t(
                        'incorrectInputAllFields'
                    );
                    this.invalidForm = true;
                    return false;
                }
                return true;
            },

            $_hasInvalidStateFields(query) {
                const invalidFields = this.inputFields.filter(
                    ({ state }) => state === false
                );
                return invalidFields.length > 0;
            },

            $_onCategoryShow(category) {
                // hide error message
                this.invalidForm = false;
                // empty all values
                this.inputFields.forEach((item) => {
                    if (item.value !== null && item.value !== '') {
                        if (item.type === FIELD_TYPE.NUMERIC || item.domain) {
                            item.value = null;
                        } else {
                            item.value = '';
                        }
                    }
                });
            },

            $_validateDate(field) {
                if (field.type === FIELD_TYPE.DATE) {
                    if (field.value.length > 0) {
                        field.state = validateDate(field.value);
                    } else {
                        field.state = null;
                    }
                    this.invalidFieldValueErrorMessage =
                        field.state === true || field.state === null
                            ? ''
                            : this.$t('labelInvalidDate');
                }
            }
        }
    };
</script>

<style scoped lang="scss">
.scrollable {
    overflow-y: auto;
}
</style>
